<template>
	<div class="start-popup-searcher">
		<div class="start-popup-searcher__searcher" :style="searcherStyle">
			<input
				class="start-popup-searcher__searcher__input"
				type="text"
				placeholder="검색할 시작팝업 제목을 입력해주세요."
				@input="input"
				@keypress.enter.prevent
				:value="propValue"
				:disabled="propSelectedPopup"
			/>
			<ul
				class="start-popup-searcher__popup-list"
				v-if="
					!propSelectedPopup &&
					searchResultList &&
					searchResultList.length > 0
				"
			>
				<li
					class="list-item"
					v-for="resultItem in searchResultList"
					:key="`searchPopupList${resultItem.idPopup}`"
				>
					<button
						type="button"
						class="start-popup-searcher__popup-list__item"
						@click="selecting(resultItem)"
					>
						({{ resultItem.idPopup }}) {{ resultItem.popupTitle }}
					</button>
				</li>
			</ul>
		</div>
		<table
			class="start-popup-searcher__selected-table table-main"
			v-if="propSelectedPopup"
		>
			<thead>
				<tr>
					<th>번호</th>
					<th>제목</th>
					<th>이미지</th>
					<th>시작일시</th>
					<th>종료일시</th>
					<th>상태</th>
					<th>삭제</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>{{ propSelectedPopup.idPopup }}</td>
					<td>{{ propSelectedPopup.popupTitle }}</td>
					<td>
						<img
							class="start-popup-searcher__selected__img"
							@click="openOriginImg(propSelectedPopup.s3Url)"
							:src="propSelectedPopup.s3Url"
							:style="imgStyle"
						/>
					</td>
					<td>{{ propSelectedPopup.startDate }}</td>
					<td>{{ propSelectedPopup.endDate }}</td>
					<td>{{ propSelectedPopup.status ? '노출' : '미노출' }}</td>
					<td>
						<button
							class="btn-delete"
							type="button"
							@click="deletingSelectedPopup"
						>
							삭제
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	import _ from 'lodash';
	import Util from '@/util';

	export default {
		name: 'StartPopupSearcher',
		props: {
			searcherWidth: {
				type: Number,
				default: 380,
			},
			searcherWidthUnit: {
				type: String,
				default: 'px',
			},
			propValue: {
				type: String,
				default: '',
			},
			propSelectedPopup: {
				type: Object,
				default: null,
			},
			imgWidthSize: {
				type: Number,
				default: 100,
			},
			imgWidthSizeUnit: {
				type: String,
				default: '%',
			},
		},
		data() {
			return {
				searchResultList: null,
			};
		},
		methods: {
			openOriginImg(path) {
				Util.popupImages([path]);
			},
			searchPopup: _.debounce(function (keyword) {
				this.$axiosAdmin2
					.get(
						`/api/popup/splashSearchList?searchKeyword=${encodeURIComponent(keyword)}`
					)
					.then(({ data }) => {
						this.searchResultList = data;
					})
					.catch(err => {
						console.error(err);
						alert('시작팝업 검색 오류입니다. 개발팀에 문의하세요.');
						this.$emit('changeValue', '');
					});
			}, 1000),
			input(e) {
				this.$emit('changeValue', e.target.value);
				if (e.target.value) this.searchPopup(e.target.value);
				else this.searchResultList = null;
			},
			selecting(item) {
				this.$emit(
					'changeValue',
					`(${item.idPopup}) ${item.popupTitle}`
				);
				this.searchResultList = null;
				this.$emit('changeItem', item);
			},
			deletingSelectedPopup() {
				this.$emit('changeValue', '');
				this.$emit('changeItem', null);
			},
			getSelectedItem() {
				return this.propSelectedPopup;
			},
		},
		computed: {
			searcherStyle() {
				return {
					width: `${this.searcherWidth}${this.searcherWidthUnit}`,
				};
			},
			imgStyle() {
				return {
					width: `${this.imgWidthSize}${this.imgWidthSizeUnit}`,
				};
			},
		},
	};
</script>

<style lang="scss" scoped>
	DIV.start-popup-searcher {
		.start-popup-searcher__searcher {
			position: relative;
		}

		.start-popup-searcher__searcher:hover {
			.start-popup-searcher__searcher__input,
			.start-popup-searcher__popup-list {
				border-color: #b0bac5;
			}
		}

		.start-popup-searcher__searcher__input:focus,
		.start-popup-searcher__searcher__input:focus
			+ .start-popup-searcher__popup-list {
			border-color: #0099fa !important;
		}

		.start-popup-searcher__popup-list {
			position: absolute;
			top: 100%;
			left: 0;
			width: 100%;
			margin: -1px 0 0 0;
			padding: 6px 0;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
			background: white;
		}

		.start-popup-searcher__popup-list__item {
			padding: 6px 12px;

			&:hover {
				color: #0099fa;
				text-decoration: underline;
			}
		}

		.start-popup-searcher__selected-table {
			width: auto;
			margin: 12px 0 0 0;
			table-layout: fixed;

			th,
			td {
				text-align: center;
				white-space: nowrap;
			}
		}

		.start-popup-searcher__selected__img {
			cursor: pointer;
		}
	}
</style>
